export const lmExclusions: string[] = [
  'blackfriday2020'
];
